// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3NEUZ","notes":"Notes_notes__YPf-R","note":"Notes_note__1X5gr","markdown":"Notes_markdown__619lb"};